import { MODULE } from "./billing.actionTypes";

export const isFetchingStatus = (state) => state.getIn([MODULE, "isFetchingStatus"]);

export const isCheckoutStatus = (state) => state.getIn([MODULE, "isCheckoutStatus"]);

export const getPricingTable = (state) => state.getIn([MODULE, "pricingTable"]);

export const getBillingDetails = (state) => state.getIn([MODULE, "billingDetails"]);
